import { render, staticRenderFns } from "./html/sparking-change-quiz.html?vue&type=template&id=4a08b0ca&scoped=true&"
import script from "./sparking-change-quiz.vue?vue&type=script&lang=js&"
export * from "./sparking-change-quiz.vue?vue&type=script&lang=js&"
import style0 from "./sparking-change-quiz.vue?vue&type=style&index=0&id=4a08b0ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a08b0ca",
  null
  
)

export default component.exports